export default __webpack_public_path__ + "static/couch-37b52c7e46a985e1738fd89431bb2004.png";